var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-vue-select',{staticClass:"payment-pack-picker",attrs:{"model":_vm.model,"values":_vm.options,"placeholder":_vm.placeholder,"ajax":true},on:{"search":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }